import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SocialChallengesModule } from '@kf-sc';
import { ChallengesRoutingModule } from '@kp/challenges/challenges-routing.module';
import { ScreenTakeActionModule } from '@kp/screen-take-action/screen-take-action.module';
import { SharedModule } from '@kp/shared/shared.module';

@NgModule({
  declarations: [ChallengesRoutingModule.components],
  imports: [CommonModule, ChallengesRoutingModule, SocialChallengesModule, ScreenTakeActionModule, SharedModule],
  exports: [ChallengesRoutingModule.components],
})
export class ChallengesModule {}
